import React from "react";
import { Workflow, useBCMSContext, BCMSRecord, useParams } from "bcms-react";
import Classes, { ACHTemplate, Company, CompanyAccount} from "model";

// Pages
import NonNachaFileImportPage from "components/pages/NonNachaFileImportPage";
import ImportFileNewTemplatePage from "components/pages/ImportFileNewTemplatePage";
import ImportFileReviewPage from "components/pages/ImportFileReviewPage";
import TemplateDetailsPage from "components/pages/TemplateDetailsPage";
import TemplatesACHPage from "components/pages/TemplatesACHPage";

// Steps of the workflow
const steps = [NonNachaFileImportPage, ImportFileNewTemplatePage, ImportFileReviewPage, TemplateDetailsPage, TemplatesACHPage];

/**
 * @function NonNachaFileImportWorkflow
 * @returns {React.Component}
 * @exported true
 * @description The main workflow component for the Non Nacha File Import workflow
 * @example
 * <OneTimeACHWorkflow />
 */
export default function NonNachaFileImportWorkflow(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { stepID } = useParams();
    const value = getDefaultData(context);

    return <Workflow value={value} steps={steps} step={stepID} />
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @exported true
 * @description Hook to return the steps of the workflow
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultData
 * @returns {OBJECT}
 * @exported true
 * @description Hook to return the default state of the workflow
 */
export const getDefaultData = () => {
    return {
        data: {
            achTemplates: [],
            achToParticipants: {
                participants: []
            },
            participants: [],
            template: ACHTemplate.init({
                id: ACHTemplate.nextID(),
                transactionType: "payment",
                secCode: "PPD Credit - Consumer Credit",
                name: "",
                companyDiscretionaryData: "",
                companyEntryDescription: "",
                creditAmount: "0.00",
                debitAmount: "0.00",
                achToParticipants: [],
                achFromAccount: [],
                company: Company.initByID(0),
                companyAccount: CompanyAccount.initByID(0),
                numberOfAccounts: "0"
            }),
            defaultTemplate:
                ACHTemplate.init({
                    id: ACHTemplate.nextID(),
                    transactionType: "payment",
                    secCode: "PPD Credit - Consumer Credit",
                    name: "SamplePPD",
                    companyDiscretionaryData: "",
                    companyEntryDescription: "",
                    creditAmount: "0.00",
                    debitAmount: "0.00",
                    achToParticipants: [],
                    achFromAccount: [],
                    company: Company.initByID(0),
                    companyAccount: CompanyAccount.initByID(0),
                    numberOfAccounts: "0"
                }),
            numberOfHeaderRows: "",
            numberOfFooterRows: "",
            inputDecimalsIntoAmounts: "No",
            textQualifier: "None",
            fileFormat: "Comma",
            chosenFileName: "SamplePPD.csv",

        },
        ui: {
            workflowType: "nonNachaFileImportWorkflow",
            isFileChosen: false,
            showOneTimeACHModal: { isActive: false },
            showSecCode: { isActive: true },
            showOffsetInvalidBanner: {isActive: false}
        }
    }
};